<template>
  <div style="display: flex;width:100%;height:100%;background-color:#D8D8D8;flex-direction: column">
    <div class="reg-header-bar" style="height: 90px;">
      <div style="width: 1000px;height:90px;margin:auto;display: flex;align-items: center">
        <img src="../../../assets/logo.png" style="width:70px;height: 70px;">
        <div style="color: white;font-size:30px;margin-left: 20px ">老刀号 超级商品说明书</div>
      </div>
    </div>
    <div style="width: 1000px;background-color: white;margin-left: auto;margin-right: auto;height: 100%">
      <div style="display:flex;margin: auto;width: 400px;height: auto">
        <Form :label-width="100" :model="reg" ref="login" style="margin:auto;width:100%">
          <h2 align="center" style="margin-top: 30px;" v-if="!isjoin">注册老刀账号</h2>
          <h2 align="center" style="margin-top: 30px;" v-if="isjoin">加入企业</h2>
          <div style="margin-top: 30px">企业信息</div>
          <FormItem label="企业名称" style="width: 400px;margin-top: 10px">
            <auto-complete @on-change="onInputChange" @on-search="onComChoose" @on-select="onOptionSelect"
                           placeholder="请输入企业名称" v-model="reg.entName">
              <Option :key="item.entId" :value="item.entName" v-for="item in data1">
                <span>{{item.entName}}</span>
              </Option>
            </auto-complete>
          </FormItem>
          <FormItem label="联系手机" style="width: 400px" v-if="entId<1 && !isjoin">
            <Input :maxlength="13" placeholder="请输入联系手机" v-model="entphone"/>
          </FormItem>
          <div style="width: 100%;height: 1px;background-color: #aaaaaa;margin: 15px 0"></div>
          <div>账号信息</div>
          <FormItem label="用户姓名" style="width: 400px;margin-top: 10px">
            <Input placeholder="请输入用户姓名" v-model="reg.name"/>
          </FormItem>
          <FormItem label="手机号码" style="width: 400px;">
            <Input :maxlength="13" @on-change="onInputPhoneChange" placeholder="请输入手机号" v-model="regphone"/>
          </FormItem>
          <FormItem label="短信验证码" style="width: 400px">
            <Input class="input-with-select" placeholder="请输入验证码" v-model="reg.smsCode">
              <Button :disabled="timeout>0" @click="getTelCode" slot="append">
                {{timeout===0?'获取验证码':`${timeout}后重试`}}
              </Button>
            </Input>
          </FormItem>
          <FormItem label="设置登录密码" style="width: 400px">
            <Input placeholder="请输入密码" type="password" v-model="reg.pwd"/>
          </FormItem>
          <FormItem label="再次输入密码" style="width: 400px">
            <Input placeholder="请再次输入密码" type="password" v-model="reg.pwdconfig"/>
          </FormItem>
          <div style="width: 100%;height: 1px;background-color: #aaaaaa;margin: 15px 0"></div>
          <Checkbox v-model="selectServer">我同意并遵守<span @click.prevent="onServiceClick"
                                                       style="color:#0060AD ">《老刀号服务协议》</span>和<span
            @click.prevent="onPrivacyClick"
            style="color:#0060AD">《隐私政策》</span>
          </Checkbox>

          <Button @click="regForm" style="width: 100%;margin-top: 60px;margin-bottom: 20px" type="primary">
            {{entId || isjoin?'加入企业':'注册'}}
          </Button>
        </Form>
      </div>
    </div>
    <Modal
      class-name="vertical-center-modal"
      footer-hide
      v-model="showServers"
      width="801">
      <div style="width: 100%">
        <h2 align="center" style="line-height: 30px">{{serviceTitle}}</h2>
        <div class="scrollbar text-style" v-html="serviceText"></div>
        <div class="flex-row">
          <Button @click="showServers=false" style="width: 120px;margin-top: 20px">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal
      class-name="vertical-center-modal"
      footer-hide
      v-model="showPrivacy"
      width="801">
      <div style="width: 100%">
        <h2 align="center" style="line-height: 30px">{{privacyTitle}}</h2>
        <div class="scrollbar text-style" v-html="sprivacyText"></div>
        <div class="flex-row">
          <Button @click="showPrivacy=false" style="width: 120px;margin-top: 20px">确定</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'Register',
  data () {
    return {
      timeout: 0,
      regphone: '',
      entphone: '',
      reg: {
        name: '',
        smsCode: '',
        pwd: '',
        pwdconfig: '',
        entName: '',
        entType: 2
      },
      data1: [],
      entId: 0,
      time: '',
      selectServer: true,
      showServers: false,
      showPrivacy: false,
      isjoin: 0,
      serviceText: '',
      serviceTitle: '',
      sprivacyText: '',
      privacyTitle: ''
    }
  },
  watch: {
    regphone (newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        if (newValue.replace(/-/g, '').length < 3) {
          this.regphone = newValue.replace(/-/g, '')
        } else if (newValue.replace(/-/g, '').length >= 3 && newValue.replace(/-/g, '').length < 7) {
          this.regphone = newValue.replace(/-/g, '').replace(/(\d{3})/, '$1-')
        } else if (newValue.replace(/-/g, '').length >= 7) {
          this.regphone = newValue.replace(/-/g, '').replace(/(\d{3})(\d{4})/, '$1-$2-')
        }
      } else {
        this.regphone = this.regphone.trim()
      }
    },
    entphone (newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        if (newValue.replace(/-/g, '').length < 3) {
          this.entphone = newValue.replace(/-/g, '')
        } else if (newValue.replace(/-/g, '').length >= 3 && newValue.replace(/-/g, '').length < 7) {
          this.entphone = newValue.replace(/-/g, '').replace(/(\d{3})/, '$1-')
        } else if (newValue.replace(/-/g, '').length >= 7) {
          this.entphone = newValue.replace(/-/g, '').replace(/(\d{3})(\d{4})/, '$1-$2-')
        }
      } else {
        this.entphone = this.entphone.trim()
      }
    }
  },
  mounted () {
    this.isjoin = this.$route.query.isjoin || 0
  },
  methods: {
    onServiceClick () {
      if (!this.serviceText) {
        this.getProtocolUser().then(res => {
          if (res.code === 0) {
            this.serviceTitle = res.data.protocloName || ''
            this.serviceText = res.data.protocloContent || ''
            this.showServers = true
          } else {
            this.$Message.info(res.msg)
          }
        })
      } else {
        this.showServers = true
      }
    },
    onPrivacyClick () {
      if (!this.sprivacyText) {
        this.getProtocolPrivacy().then(res => {
          if (res.code === 0) {
            this.privacyTitle = res.data.protocloName || ''
            this.sprivacyText = res.data.protocloContent || ''
            this.showPrivacy = true
          } else {
            this.$Message.info(res.msg)
          }
        })
      } else {
        this.showPrivacy = true
      }
    },
    onInputPhoneChange () {
      if (this.timeout) {
        clearInterval(this.time)
        this.timeout = 0
        this.time = ''
      }
    },
    onOptionSelect (value) {
      // console.log(value)
    },
    onInputChange (value) {
      if (this.data1 && this.data1.length) {
        let resultarry = this.data1.filter(res => {
          return res.entName === value
        })
        if (resultarry && resultarry.length === 1) {
          this.entId = resultarry[0].entId
        } else {
          this.entId = 0
        }
      } else {
        this.entId = 0
      }
    },
    onComChoose (value) {
      this.data1 = []
      if (value) {
        // this.getentlistbyname(value).then(res => {
        //   if (res.code === 0) {
        //     this.data1 = res.data.list
        //   } else {
        //     this.data1 = []
        //   }
        //   let resultarry = this.data1.filter(res => {
        //     return res.entName === value
        //   })
        //   if (resultarry && resultarry.length === 1) {
        //     this.entId = resultarry[0].entId
        //   } else {
        //     this.entId = 0
        //   }
        // })
      } else {
        this.data1 = []
        this.entId = 0
      }

    },
    getTelCode () {
      let phone = this.regphone.replace(/-/g, '')
      if (phone.length < 1) {
        this.$Message.info('请输入手机号码')
        return
      }
      this.postSmsReg(phone).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.code) {
            this.reg.smsCode = res.data.code || ''
          }
          let seconds = 60
          let self = this
          self.time = setInterval(() => {
            --seconds
            self.timeout = seconds
            if (seconds <= 0) {
              clearInterval(self.time)
            }
          }, 1000)
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    regForm () {
      if (!this.selectServer) {
        return
      }

      if (this.isjoin && this.entId < 1) {
        return this.$Message.info('请选择企业')
      }
      let regphone = this.regphone.replace(/-/g, '')
      let entphone = this.entphone.replace(/-/g, '')
      let params = {
        name: this.reg.name,
        phone: regphone,
        smsCode: this.reg.smsCode,
        pwd: this.reg.pwd,
        pwdconfig: this.reg.pwdconfig,
        entName: this.reg.entName,
        entphone: entphone,
        entType: this.reg.entType
      }
      if (!params.entName.length) {
        this.$Message.info('请输入企业名称')
        return
      }
      if (!params.phone.length) {
        this.$Message.info('请输入手机号码')
        return
      }
      if (this.entId) {
        params.entId = this.entId
        params.entName = ''
      }

      if (!params.pwd) {
        return this.$Message.info('请输入密码')
      }

      if (params.pwd !== params.pwdconfig) {
        return this.$Message.info('2次输入密码不一致')
      }

      this.regEnt(params).then(res => {
        if (res.code === 0) {
          this.$router.replace('/login')
        } else if (res.code === 106122) {
          this.joinEnt(params).then(res1 => {
            if (res1.code === 0) {
              this.$router.replace('/login')
            } else {
              this.$Message.info(res1.msg)
            }
          })
        } else {
          this.$Message.info(res.msg)
        }
      })

    },
    ...mapActions([
      'postSmsReg',
      'regEnt',
      'getentlistbyname',
      'joinEnt',
      'getProtocolUser',
      'getProtocolPrivacy'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .reg-header-bar {
    background: url("../../../assets/common/ic_header_bg.png");
  }

  .text-style {
    max-height: 500px;
    overflow-y: auto;
  }
</style>
